import React from 'react'
import t from 'prop-types'

const Breadcrumbs = ({ crumbs }) => {
  return (
    <ul className="breadcrumbs">
      {crumbs.map((crumb, idx) => (
        <span className="font-sans font-base leading-tight text-blue-200 uppercase">
          <a href={crumb.link.url} className="hover:text-chartreuse">
            {crumb.link.title}
          </a>
          <span className="mx-2">{crumbs.length !== idx + 1 && '|'}</span>
        </span>
      ))}
    </ul>
  )
}

Breadcrumbs.propTypes = {
  crumbs: t.array,
}

Breadcrumbs.defaultProps = {}

export default Breadcrumbs
